import type {
  DisconnectOAuthResponse,
  GDriveSyncStatusResponse,
  InitiateOAuthResponse,
} from "@nlc/shared-types";

import authenticatedApi from "@/lib/api/client";

export async function getGoogleOAuthUrl(): Promise<InitiateOAuthResponse> {
  return authenticatedApi
    .url("/oauth/google")
    .get()
    .json<InitiateOAuthResponse>();
}

export async function getGoogleOAuthStatus(): Promise<GDriveSyncStatusResponse> {
  return authenticatedApi
    .url("/oauth/google/status")
    .get()
    .json<GDriveSyncStatusResponse>();
}

export async function disconnectGoogleOAuth(): Promise<DisconnectOAuthResponse> {
  return authenticatedApi
    .url("/oauth/google")
    .delete()
    .json<DisconnectOAuthResponse>();
}
